module.exports = __webpack_public_path__ + "img/334.ba690629.png";